<template>
  <div class="cmp-wrapper">
    <basic-container>
      <el-form
        ref="subjectForm"
        :model="formData"
        :rules="rules"
        label-width="140px"
        label-position="left"
        size="mini"
      >
        <el-form-item label="主体名称" prop="subjectName">
          <el-input v-model.trim="formData.subjectName" placeholder="请输入主体名称"></el-input>
        </el-form-item>

        <h2 class="title">营业执照</h2>
        
        <el-form-item label="营业执照" prop="licensePic">
          <store-img-upload type="licensePic" @fileList="(data) => formData.licensePic= data[0]"/>
          <p>营业执照图片必须加盖工商局和公司的公章，原件/复印件/扫描件图片均可，上传一张，大小不超过2M（支持jpg,jpeg,png格式）</p>
        </el-form-item>
        <el-form-item label="执照类型" prop="licenseType">
          <el-radio v-model="formData.licenseType" :label="1">企业</el-radio>
          <el-radio v-model="formData.licenseType" :label="2">个体工商户</el-radio>
        </el-form-item>
        <el-form-item label="公司名称" prop="corpName">
          <el-input v-model.trim="formData.corpName" placeholder="请输入公司名称"></el-input>
        </el-form-item>
        <el-form-item label="统一社会信用代码" prop="uniformSocialCreditCode">
          <el-input v-model.trim="formData.uniformSocialCreditCode" placeholder="请输入统一社会信用代码"></el-input>
        </el-form-item>
        <el-form-item label="注册地址" prop="registerAddress">
          <el-input v-model.trim="formData.registerAddress" placeholder="请输入注册地址"></el-input>
        </el-form-item>
        <el-form-item label="证件有效截止日期" prop="expireType">
          <el-radio v-model="formData.expireType" :label="1">固定有效日期</el-radio>
          <el-date-picker
            v-model="formData.expireDate"
            :disabled="formData.expireType!== 1"
            v-if="formData.expireType=== 1"
            type="date"
            :picker-options="pickerOptions"
            :default-value="new Date()"
            style="margin-right: 20px;"
            format="yyyy-MM-dd"
            value-format="timestamp"
            placeholder="选择日期" />
          <el-radio v-model="formData.expireType" :label="2">长期有效</el-radio>
        </el-form-item>
        <el-form-item label="纳税性质" prop="taxType">
          <el-select v-model="formData.taxType" placeholder="请选择">
            <el-option label="一般纳税人" value="1"></el-option>
            <el-option label="小规模纳税人" value="2"></el-option>
          </el-select>
        </el-form-item>
        
        <br/>
        <h2 class="title">法人信息</h2>
        <br/>
        <el-form-item label="上传身份证人像面" prop="idCardPortraitSide">
          <store-img-upload type="licensePic" @fileList="(data) => formData.idCardPortraitSide= data[0]"/>
          <p>身份证图片原件/复印件/扫描件图片均可，上传一张，大小不超过2M（支持支持jpg,jpeg,png格式）</p>
        </el-form-item>

        <el-form-item label="上传身份证国徽面" prop="idCardEmblemSide">
          <store-img-upload type="licensePic" @fileList="(data) => formData.idCardEmblemSide= data[0]"/>
          <p>身份证图片原件/复印件/扫描件图片均可，上传一张，大小不超过2M（支持支持jpg,jpeg,png格式）</p>
        </el-form-item>
        <el-form-item label="法人姓名" prop="legalPersonName">
          <el-input v-model.trim="formData.legalPersonName" placeholder="请输入法人姓名"></el-input>
        </el-form-item>
        <el-form-item label="法人身份证号" prop="legalPersonIdCardNo">
          <el-input v-model.trim="formData.legalPersonIdCardNo" placeholder="请输入法人身份证号"></el-input>
        </el-form-item>
        <el-form-item label="法人实名手机号" prop="legalPersonPhone">
          <el-input v-model.trim="formData.legalPersonPhone" placeholder="请输入法人实名有效手机号"></el-input>
        </el-form-item>
      </el-form>
      <div class="footer">
        <el-button size="mini" @click="handleBack">取消</el-button>
        <el-button size="mini" type="primary" @click="onSubmit">保存并提交</el-button>
      </div>
    </basic-container>
  </div>
</template>

<script>
import { callbackify } from "util";
export default {
  name: "subject-message",
  data() {
    var checkRegNum = (rules, val, callback) => {
    if(!val) callback(new Error("请输入注册号"))
    else if(val.length> 20) callback(new Error("注册号不得超过20位"))
      callback()
    }
    var checkLisenceName = (rules, val, callback) => {
      if(!val) callback(new Error("请输入营业执照名称"))
      else if(val.length> 32) callback(new Error("营业执照名称不得超过32位"))
      callback()
    };
    var checkRegisterAddress = (rules, val, callback) => {
      if(!val) callback(new Error("请输入注册地址"))
      else if(val.length> 100) callback(new Error("注册地址不得超过100位"))
      callback()
    };
    var checkLicensePic=  (rules, val, callback)=> {
      const {licensePic}= this.formData
      if(licensePic === "") callback(new Error("请上传营业执照"))
      callback()
    }
    var checkSubjectName = (rules, val, callback) => {
      const {subjectName}= this.formData
      if (subjectName.length >30)
        callback(new Error("主体名称不超过30字"));
      if (subjectName.length === 0)
        callback(new Error("主体名称不能为空"));
      callback();
    };
    var checkCardPortrait=  (rules, val, callback)=> {
      const {idCardPortraitSide}= this.formData
      if(idCardPortraitSide === "") callback(new Error("请上传身份证人像面"))
      callback()
    }
    var checkCardEmblem=  (rules, val, callback)=> {
      const {idCardEmblemSide}= this.formData
      if(idCardEmblemSide === "") callback(new Error("请上传身份证国徽面"))
      callback()
    }
    var checkExpireType= (rules, val, callback)=> {
      const {expireType, expireDate}= this.formData
      if(expireType=== 1 && !expireDate) callback(new Error("请选择证件有效期"))
      callback()
    }

    return {
      formData: {
        subjectName: "",
        corpName: "",
        legalPersonName: "",
        legalPersonPhone: "",
        legalPersonIdCardNo: "",
        registerAddress: "",
        licensePic: '',
        idCardPortraitSide: '',
        idCardEmblemSide: '',
        licenseName: '',
        licenseType: '',
        expireType: 1,
        expireDate: '',
        uniformSocialCreditCode: '',
        registerAddress: '',
        taxType: ''
      },
      text: [],
      timeText: [],
      startTime: "",
      endTime: "",
      rules: {
        subjectName: [
          {
            required: true,
            validator: checkSubjectName
          }
        ],
        legalPersonName: [
          {
            required: true,
            message: "请输入联系人姓名"
          }
        ],
        legalPersonPhone: [
          {
            required: true,
            message: "请输入联系人电话"
          }
        ],
        legalPersonIdCardNo: [
          {
            required: true,
            message: "请输入法人身份证号"
          }
        ],
        taxType: [
          {
            required: true,
            message: "请选择纳税性质"
          }
        ],
        
        licenseType: [
          {
            required: true,
            message: "请选择营业执照类型"
          }
        ],
        registerAddress: [{required: true, validator: checkRegisterAddress}],
        corpName: [{required: true, validator: checkLisenceName}],
        uniformSocialCreditCode: [{required: true, validator: checkRegNum}],
        expireType: [{required: true, validator: checkExpireType}],
        licensePic: [{required: true, validator: checkLicensePic}],
        idCardPortraitSide: [{required: true, validator: checkCardPortrait}],
        idCardEmblemSide: [{required: true, validator: checkCardEmblem}],
      },
      pickerOptions: {
        disabledDate: (time) => {
          const now = new Date()
          const year = now.getFullYear()
          const month = now.getMonth()
          const day = now.getDate()-1
          return time.getTime() < new Date(year, month, day, 23, 59, 59).getTime()
        }
      },
    };
  },
  // watch: {
  //   storeManagementType: function(val) {
  //     const [classB, classC] = val;
  //     Object.assign(this.formData, { classB, classC });
  //   }
  // },
  created() {
    
  },
  beforeRouteLeave(to, from, next) {
      this.$refs.subjectForm.resetFields(); 
      this.$destroy();
      next();
    },
  methods: {
    handleBack() {
      this.$router.go(-1);
    },
    onSubmit() {
      this.$refs["subjectForm"].validate(val => {
        if (val) {
          this.save();
        } else {
          this.$message({
            type: "warning",
            message: "请完成信息后提交"
          });
        }
      });
    },
    async save() {
      if(this.formData.expireType=== 2) this.formData.expireDate= new Date().getTime()
      this.formData.expireDate/= 1000
      const {
        data: { subjectId }
      } = await _api.splitAcc.subjectCreate(this.formData);
      if (subjectId) {
        this.$message({
          message: '主体提交成功，请等待审核结果',
          type: 'success'
        }
        );
        this.handleBack();
      }
      this.formData.expireDate= "";
    }
  }
};
</script>
<style scoped>
.el-input {
  width: 300px;
}
.el-textarea {
  width: 400px;
}
.el-select {
  width: 130px;
}
.title {
  font-weight: 900;
  font-size: 18px;
}
</style>
